import type { PersistConfig } from "redux-persist";
import { createSparxsEditorSessionIndexedDbStorage } from "@/store/persistence/sparxsEditorSessionIndexedDbStorage";
import type { SparxsBlueprintCacheState } from "@/store/sparxsCatalog/blueprintCacheSlice";
import type { SparxsListState } from "@/store/sparxsCatalog/listSlice";
import type { SparxsSearchIndexState } from "@/store/sparxsCatalog/searchIndexSlice";

export const sparxsListPersistConfig: PersistConfig<SparxsListState> = {
  key: "sparxsList",
  storage: createSparxsEditorSessionIndexedDbStorage(),
  whitelist: ["data", "excludedData"],
};

export const sparxsBlueprintCachePersistConfig: PersistConfig<SparxsBlueprintCacheState> =
  {
    key: "sparxsBlueprintCache",
    storage: createSparxsEditorSessionIndexedDbStorage(),
    whitelist: ["byFileName"],
  };

export const sparxsSearchIndexPersistConfig: PersistConfig<SparxsSearchIndexState> =
  {
    key: "sparxsSearchIndex",
    storage: createSparxsEditorSessionIndexedDbStorage(),
    whitelist: ["rowsByFileName"],
  };
